import React, { useEffect } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { useCheckRoutingInfoQueryCache } from "#/components/carrot-plans/shared/useQueryRoutingInfo"
import { Journey } from "#/components/carrot-plans/types/journey"
import { HelpfulOption } from "#/components/carrot-plans/most-helpful-options/helpfulOption"

export default function WhatKindOfJourneyShareBackgroundDecisionStep(): JSX.Element {
  const routingData = useCheckRoutingInfoQueryCache()
  const journeyValue = routingData?.journey as Journey

  const journeysToCheckMostHelpful = [
    Journey.PREGNANT,
    Journey.TRY_PREGNANT,
    Journey.ASSISTED_REPRODUCTION,
    Journey.MENOPAUSE,
    Journey.PRESERVATION,
    Journey.EXPLORING,
    Journey.GESTATIONAL,
    Journey.LOW_TESTOSTERONE,
    Journey.GENDER_AFFIRMING_CARE
  ]

  const isProviderHelpRequestedForEligibleJourney =
    routingData?.mostHelpfulNow?.includes(HelpfulOption.HELP_FINDING_PROVIDER) &&
    journeysToCheckMostHelpful.includes(journeyValue)

  const decisionValue = isProviderHelpRequestedForEligibleJourney ? "HELP_FINDING_PROVIDER" : "NEXT_STEP"

  const { send } = useStateMachine()
  useEffect(() => {
    send(decisionValue)
  })
  return <></>
}
